import HttpClient from "../../utils/http";


export function getSurveyorDetails(surveyorId: string) {
    return HttpClient.get(`getUserData?userId=${surveyorId}`);
}